import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_STEP_COUNTS = gql`
    query OnboardingStepCounts {
        onboardingStepCounts {
            step
            count
        }
    }
`;

const useOnboardingStepCounts = () => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_STEP_COUNTS, {
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingStepCounts,
        loading,
        error,
        refetch,
    };
};

export default useOnboardingStepCounts;
